import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Sticky from 'react-stickynode';

import { getNav } from 'actions/NavActions';
import { getUserContext } from 'actions/UserActions';

// util is not aliased, see webpack config for why
import InnerHTML from '../../../util/ScriptInnerHtml';

// make sure this website nav gets loaded in a <StickyContainer/>
class UnifiedNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav: '',
      isHidden: props.isHidden
    };
  }

  componentDidMount() {
    const { user, onGetNav, fetchUserContext } = this.props;

    onGetNav().then(nav => this.setState({ nav }));

    if (!user) {
      fetchUserContext();
    }
  }

  render() {
    const { enableSticky } = this.props;
    const { nav, isHidden } = this.state;
    const defaultStyles = { height: 60, transform: 'none', backgroundColor: '#FFF' };
    const hiddenStyles = isHidden ? { position: 'absolute', left: '-99999px' } : {};
    const styles = {
      ...defaultStyles,
      ...hiddenStyles
    };
    return (
      <div style={styles}>
        <Sticky innerZ={500} enableTransforms={false} enabled={enableSticky}>
          <InnerHTML html={nav} />
        </Sticky>
      </div>
    );
  }
}

UnifiedNav.propTypes = {
  user: PropTypes.shape({}),
  fetchUserContext: PropTypes.func.isRequired,
  onGetNav: PropTypes.func,
  enableSticky: PropTypes.bool,
};

UnifiedNav.defaultProps = {
  user: null,
  enableSticky: true,
};

const mapStateToProps = state => ({
  user: state.user.userContext
});

const mapDispatchToProps = dispatch => ({
  fetchUserContext: () => dispatch(getUserContext()),
  onGetNav: () => dispatch(getNav())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnifiedNav);



// WEBPACK FOOTER //
// ./src/components/common/header/UnificationNav/UnificationNav.jsx